import { Routes } from '@angular/router';
import { AdminComponent } from '@pages/admin/admin.component';
import { AggregatesComponent } from '@pages/audit/aggregates/aggregates.component';
import { AuditDashboardComponent } from '@pages/audit/audit-dashboard/audit-dashboard.component';
import { AuditComponent } from '@pages/audit/audit.component';
import { RoutinesMonitorComponent } from '@pages/audit/routines-monitor/routines-monitor.component';
import { DoctorsListComponent } from '@pages/doctors/doctors-list/doctors-list.component';
import { DoctorsComponent } from '@pages/doctors/doctors.component';
import { PatientDetailComponent } from '@pages/doctors/patient-detail/patient-detail.component';
import { PatientKitsComponent } from '@pages/doctors/patient-kits/patient-kits.component';
import { PatientListComponent } from '@pages/doctors/patient-list/patient-list.component';
import { PatientReportDetailComponent } from '@pages/doctors/patient-report-detail/patient-report-detail.component';
import { PatientReportsComponent } from '@pages/doctors/patient-reports/patient-reports.component';
import { LoginComponent } from '@pages/login/login/login.component';
import { OrganizationDetailComponent } from '@pages/organization/organization-detail/organization-detail.component';
import { OrganizationFormComponent } from '@pages/organization/organization-form/organization-form.component';
import { OrganizationTableComponent } from '@pages/organization/organization-table/organization-table.component';
import { OrganizationComponent } from '@pages/organization/organization.component';
import { AddNewProductComponent } from '@pages/products/add-new-product/add-new-product.component';
import { ProductsListComponent } from '@pages/products/products-list/products-list.component';
import { ProductsComponent } from '@pages/products/products.component';
import { ReportsRequestsComponent } from '@pages/reports-requests/reports-requests.component';
import { RequestDetailComponent } from '@pages/reports-requests/request-detail/request-detail.component';
import { RequestsComponent } from '@pages/reports-requests/requests/requests.component';
import { adminOnlyGuard, tokenCheckGuard } from '@services/guards/token-check.guard';
import { LayoutComponent } from './components/layout/layout.component';
import {B2cOperationsComponent} from './pages/b2c-operations/b2c-operations.component';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [tokenCheckGuard],
    children: [
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [adminOnlyGuard]
      },
      {
        path: 'doctors',
        component: DoctorsComponent,
        canActivate: [adminOnlyGuard],
        children: [
          {
            path: '',
            component: DoctorsListComponent,
          },
          {
            path: ':doctorId/patients',
            component: PatientListComponent
          },
          {
            path: ':doctorId/patients/:patientId',
            component: PatientDetailComponent
          },
          {
            path: ':doctorId/patients/:patientId/reports',
            component: PatientReportsComponent
          },
          {
            path: ':doctorId/patients/:patientId/kits',
            component: PatientKitsComponent
          },
          {
            path: ':doctorId/patients/:patientId/reports/create',
            component: PatientReportDetailComponent
          },
          {
            path: ':doctorId/patients/:patientId/reports/:reportId',
            component: PatientReportDetailComponent
          },
        ]
      },
      {
        path: 'products',
        component: ProductsComponent,
        canActivate: [adminOnlyGuard],
        children: [
          {
            path: '',
            component: ProductsListComponent
          },
          {
            path: 'add-new',
            component: AddNewProductComponent
          },
        ]
      },
      {
        path: 'requests',
        component: ReportsRequestsComponent,
        children: [
          {
            path: '',
            component: RequestsComponent,
          },
          {
            path: ':requestId',
            component: RequestDetailComponent
          }
        ]
      },
      {
        path: 'organization',
        component: OrganizationComponent,
        canActivate: [adminOnlyGuard],
        children: [
          {
            path: '',
            component: OrganizationTableComponent
          },
          {
            path: 'new',
            component: OrganizationFormComponent
          },
          {
            path: ':organizationId',
            component: OrganizationDetailComponent
          },
        ]
      },
      {
        path: 'b2c',
        canActivate: [adminOnlyGuard],
        children: [
          {
            path: '',
            component: B2cOperationsComponent,
          },
          {
            path: 'patients/:patientId/reports',
            component: PatientReportsComponent
          },
          {
            path: 'patients/:patientId/reports/create',
            component: PatientReportDetailComponent
          },
          {
            path: 'patients/:patientId/reports/:reportId',
            component: PatientReportDetailComponent
          },
        ]
      },
      {
        path: 'patients/:patientId/reports',
        component: PatientReportsComponent,
        canActivate: [adminOnlyGuard]
      },
      {
        path: 'patients/:patientId/reports/create',
        component: PatientReportDetailComponent,
        canActivate: [adminOnlyGuard]
      },
      {
        path: 'patients/:patientId/reports/:reportId',
        component: PatientReportDetailComponent,
        canActivate: [adminOnlyGuard]
      },
      {
        path: 'audit',
        component: AuditComponent,
        canActivate: [adminOnlyGuard],
        children: [
          {
            path: 'events',
            component: AuditDashboardComponent,
          },
          {
            path: 'routines',
            component: RoutinesMonitorComponent,
          },
          {
            path: 'aggregates',
            component: AggregatesComponent,
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'events',
          },
        ]
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/doctors'
      }
    ]
  }
];
